import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { Tree, Input, Tooltip, AutoComplete } from "antd";
import { UserOutlined } from "@ant-design/icons";

import ContextMenu from "components/imagemanager/contextmenu/contextmenu";

const { Option } = AutoComplete;
const { Search } = Input;
// const { DirectoryTree } = Tree;

export default class TreeNodes extends React.Component<any, any> {
  cmContainer: any;
  toolTip: any;

  constructor(props: any) {
    super(props);

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.onRightClick = this.onRightClick.bind(this);
    this.handleCreateDirClick = this.handleCreateDirClick.bind(this);
    this.handleDelDir = this.handleDelDir.bind(this);
    this.handleRenameDir = this.handleRenameDir.bind(this);
    this.handleCancelDelDir = this.handleCancelDelDir.bind(this);
    this.handleSelectNode = this.handleSelectNode.bind(this);
  }
  state = {
    // nodes: [],
    searchFolderKeyword: null,
    isContextMenuVisible: true,
  };
  componentDidMount() {
    this.getContainer();
  }

  componentWillUnmount() {
    if (this.cmContainer) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      document.body.removeChild(this.cmContainer);
      this.cmContainer = null;
    }
  }

  // 创建右键菜单容器
  getContainer() {
    if (!this.cmContainer) {
      this.cmContainer = document.createElement("div");
      document.body.appendChild(this.cmContainer);
    }
    return this.cmContainer;
  }

  removeContextMenu() {
    if (this.toolTip) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      this.toolTip = null;
    }
  }

  handleCancelDelDir() {
    this.removeContextMenu();
    console.log("cancel del");
  }

  renderCm(e: any, node: any) {
    this.removeContextMenu();
    this.toolTip = (
      <Tooltip
        // trigger="click"
        trigger="contextMenu"
        placement="bottomRight"
        // prefixCls="tree-contextmenu"
        destroyTooltipOnHide
        defaultVisible
        // visible={this.state.isContextMenuVisible}
        title={
          <ContextMenu
            node={node}
            onConfirmDel={this.handleDelDir}
            onCancelDel={this.handleCancelDelDir}
            onCreateDir={this.handleCreateDirClick}
            onRenameDir={this.handleRenameDir}
          />
        }
      />
    );

    const container = this.getContainer();
    Object.assign(this.cmContainer.style, {
      position: "absolute",
      left: `${e.pageX + 80}px`,
      top: `${e.pageY - 10}px`,
    });

    ReactDOM.render(this.toolTip, container);
  }

  // onExpand = (expandedKeys: any, { expanded, node }) => {
  //   // this.setState({
  //   //   expandedKeys,
  //   //   autoExpandParent: false,
  //   // });
  //   // console.log(expandedKeys, expanded, node);
  //   // const { id } = node;
  // };

  onRightClick({ event, node }: any) {
    // if (node.title === "图片" || node.title === "视频") return false;
    console.log("right click", event, node);
    // this.setState({ isContextMenuVisible: true });
    // this.setState({ selectedKeys: [info.node.props.eventKey] });
    this.renderCm(event, node);
  }

  handleCreateDirClick(node: any) {
    console.log("createdir", node);
    this.removeContextMenu();
    this.props.onCreateDirModalShow(node);
  }

  handleDelDir(node) {
    this.props.onDeleteFolder({ id: node.id });
    this.removeContextMenu();
  }

  handleRenameDir() {
    console.log("rename dir");
  }

  handleSearchChange(value) {
    // const { value } = e.target;
    console.log(value);
    this.setState({
      searchFolderKeyword: value,
    });
    this.props.onSearchFolder(value);
  }

  handleSelectNode(selectedKeys, e: { selected; selectedNodes; node; event }) {
    // console.log(selectedKeys, e);
    const { node } = e;
    const { id } = node;
    const { currentFolderId, onTreeSelect } = this.props;
    // console.log(node);
    // console.log(11111, currentFolderId);]
    // todo 选中时异步加载数据会导致动画卡顿
    if (id !== currentFolderId) {
      onTreeSelect(node);
    }
  }

  // warning:deprecated! do not delete!
  // buildTreeNodes(treenode: any) {
  //   let nodes = [];
  //   // let node = [];
  //   for (const item of treenode) {
  //     if (item.children && item.children.length > 0) {
  //       nodes.push(
  //         <TreeNode key={item.id} title={item.folderName}>
  //           {this.buildTreeNodes(item.children)}
  //         </TreeNode>
  //       );
  //     } else {
  //       nodes.push(<TreeNode key={item.id} title={item.folderName} />);
  //     }
  //   }
  //   return nodes;
  // }

  // buildTreeData(data: any): any {
  //   let nodes = [];
  //   // let node = [];
  //   for (const item of data) {
  //     if (item.children && item.children.length > 0) {
  //       nodes.push({
  //         key: item.id,
  //         pid: item.pid,
  //         title: item.folderName,
  //         children: this.buildTreeData(item.children),
  //       });
  //     } else {
  //       nodes.push({ key: item.id, pid: item.pid, title: item.folderName });
  //     }
  //   }
  //   return nodes;
  // }

  // renderTitle = (title: string) => {
  //   return (
  //     <span>
  //       {title}
  //       <a
  //         style={{ float: "right" }}
  //         href="https://www.google.com/search?q=antd"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         more
  //       </a>
  //     </span>
  //   );
  // };

  // renderItem = (title: string, count: number) => {
  //   return {
  //     value: title,
  //     label: (
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //         }}
  //       >
  //         {title}
  //         <span>
  //           <UserOutlined /> {count}
  //         </span>
  //       </div>
  //     ),
  //   };
  // };

  renderFolderName(name: string) {
    const { searchFolderKeyword } = this.state;
    if (name.includes(searchFolderKeyword)) {
      const reg = new RegExp(searchFolderKeyword, "g");
      return name.replace(
        reg,
        `<span style=color:red>${searchFolderKeyword}</span>`
      );
    }
    // splitedName.splice(0, 0, <span style={{ color: "red" }}>{keyword}</span>);
    // console.log(splitedName);
    return name;
  }

  render() {
    const { treeData, searchedFolders } = this.props;
    // console.log(searchedFolders);
    return (
      <Fragment>
        <AutoComplete
          style={{ width: 165, marginBottom: 10 }}
          // options={options}
          onSearch={this.handleSearchChange}
          placeholder={"搜文件夹来这里~"}
        >
          {searchedFolders.map((folder) => {
            return (
              <Option value={folder.id + ""} key={folder.id}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.renderFolderName(folder.folderName),
                  }}
                />
              </Option>
            );
          })}
        </AutoComplete>
        <Tree
          virtual={false}
          showLine={false}
          treeData={treeData}
          showIcon={false}
          // expandedKeys={expandedKeys}
          // autoExpandParent={autoExpandParent}
          onSelect={this.handleSelectNode}
          // onExpand={this.onExpand}
          onRightClick={this.onRightClick}
        />
      </Fragment>
    );
  }
}
